# Create a dummy analytics object until real loaded
window.fedoraAnalytics or (window.fedoraAnalytics = [])
window.fedoraAnalytics.methods = [
  'identify'
  'track'
  'trackLink'
  'trackForm'
  'trackClick'
  'trackSubmit'
  'page'
  'pageview'
  'ab'
  'alias'
  'ready'
  'group'
  'on'
  'once'
  'off'
]

window.fedoraAnalytics.factory = (method) ->
  return ->
    args = Array::slice.call(arguments)
    args.unshift method
    window.fedoraAnalytics.push args
    window.fedoraAnalytics

i = 0
while i < window.fedoraAnalytics.methods.length
  method = window.fedoraAnalytics.methods[i]
  window.fedoraAnalytics[method] = window.fedoraAnalytics.factory(method)
  i++
# Load analytics async

window.fedoraAnalytics.load = (callback) ->
  if document.getElementById('analytics-js')
    return
  # We make a copy if our dummy object
  window.a = window.fedoraAnalytics
  script = document.createElement('script')
  script.async = true
  script.id = 'analytics-js'
  script.type = 'text/javascript'
  script.src = '/analytics.js'
  script.addEventListener 'load', ((e) ->
    if typeof callback is 'function'
      callback e
    return
  ), false
  first = document.getElementsByTagName('script')[0]
  first.parentNode.insertBefore script, first
  return

# Events we send to our own (Teachable) Google Analytics
window.trackTeachableGAEvent = (name, properties) ->
  eventProperties = analyticsEvents()[0]?.properties
  courseName = eventProperties?.name || eventProperties?.products?[0].name
  currency = eventProperties?.currency
  switch name
    when "Added Product"
      trackTeachableGAEvent("Completed Checkout Step", { name: "Completed Checkout Step", step: 1 })
      try
        ga("fedoraTracker.ec:addProduct", properties)
        ga("fedoraTracker.ec:setAction", "add")
      catch
    when "Completed Checkout Step"
      try
        ga("fedoraTracker.ec:setAction", "checkout", properties)
      catch
    when "Completed Order"
      product = eventProperties?.products?[0]
      sale = {
        id: eventProperties?.orderId,
        revenue: eventProperties?.total,
        coupon: eventProperties?.coupon,
        tax: eventProperties?.net_tax_charge,
      }
      try
        ga("fedoraTracker.set", "currencyCode", currency)
        ga("fedoraTracker.ec:addProduct", product)
        ga("fedoraTracker.ec:setAction", "purchase", sale)
        ga("fedoraTracker.send", "event", "EnhancedEcommerce", "Completed Order", {nonInteraction: 1})
      catch
  try
    ga('fedoraTracker.send', {
      hitType: 'event'
      eventCategory: courseName
      eventAction: name
      eventLabel: name
    })
  catch
  return

window.analyticsOptions = ->
  options = document.querySelector("meta[name='analytics']")?.dataset
  if typeof(options) == "undefined"
    return {analytics: {}, events: []}
  else
    return options

analyticsKeys = ->
  analytics = analyticsOptions().analytics
  analytics and JSON.parse(analytics) || {}

analyticsEvents = ->
  events = analyticsOptions().events
  events and JSON.parse(events) || []

trackBackendEvent = (eventData) ->
  window.analytics.track(eventData.name, eventData.properties) if window.analytics && segmentEnabled()
  fedoraAnalytics.track(eventData.name, eventData.properties)
  trackTeachableGAEvent(eventData.name, eventData.properties)

trackBackendEvents = (events) ->
  return unless _.isArray(events) and events.length > 0
  _.forEach(events, trackBackendEvent)

currentUser = -> document.querySelector("#fedora-data").dataset

trackUser = (currentUser) ->
  return unless currentUser?.id
  userInfo = {
    name: currentUser.name
    userId: currentUser.id
    role: currentUser.role
    email: currentUser.email
    createdAt: currentUser.joinedAt and currentUser.joinedAt.replace(/"/g,"")
    avatar: currentUser.gravatarUrl
  }
  try
    fedoraAnalytics.identify(currentUser.id, userInfo)
    if window.analytics && segmentEnabled()
      analytics.identify(currentUser.id, userInfo)
  catch
  return

segmentEnabled = -> analyticsKeys()["Segment.io"]?.apiKey

trackPage = ->
  pageName = document.title
  settings = {
    location: window.location.href,
    path: window.location.pathname
  }
  # Send to segment if set
  if window.analytics && segmentEnabled()
    window.analytics.page(pageName, settings)
  # send to analytics.js
  fedoraAnalytics.page(pageName, settings)
  return

window.trackEvent = (eventName, data = {}) ->
  schoolPreferences = currentUser().schoolPreferences
  parsedSchoolPrefs = schoolPreferences and JSON.parse(schoolPreferences)
  shouldNotSendEvents = parsedSchoolPrefs.disable_js_course_event_tracking == "true"

  if shouldNotSendEvents == true
    return

  try
    if segmentEnabled()
      analyticsTrackBegin = Date.now()
      analyticsTrackInterval = setInterval(->
        if (window.analytics?.track)
          clearInterval(analyticsTrackInterval)

          window.analytics.track(eventName, data)
        else
          if (Date.now() - analyticsTrackBegin > 2000)
            console.log("failed to track #{eventName}, adblock may be enabled")
      , 10)
    else
      fedoraAnalytics.track(eventName, data)
  catch
    console.log("failed to track #{eventName}, adblock may be enabled")
  return

fedoraAnalytics.load ->
  keys = analyticsKeys()
  delete keys?["Segment.io"]
  window.fedoraAnalytics.initialize keys
  while window.a.length > 0
    item = window.a.shift()
    method = item.shift()
    if fedoraAnalytics[method]
      fedoraAnalytics[method].apply fedoraAnalytics, item
  return

initAnalytics = ->
  publishPageAnalyticsEvents()
  return
publishPageAnalyticsEvents = ->
  backendEvents = analyticsEvents()
  user = currentUser()
  trackUser(user)
  trackPage()
  trackBackendEvents(backendEvents)

document.addEventListener("ready", initAnalytics)
document.addEventListener("DOMContentLoaded", initAnalytics)
